// Per-field business-address validation actions.
//
// Unlike the person/employee address flow (which keeps a single validated slot in
// employeeReducer.personAddressOptions), a business enrolment page can show more
// than one address at once - e.g. a Corporate Legal Address and a separate Mailing
// Address. Every action here carries a `fieldKey` so each address input tracks its
// own suggestions and "validated" flag and one never clobbers the other.

export const verifyBusinessAddress = (data: {
  fieldKey: string;
  searchString: string;
}): { type: string; data: any } => ({
  type: "VERIFY_BUSINESS_ADDRESS",
  data,
});

export const updateBusinessAddressOptions = (data: {
  fieldKey: string;
  [key: string]: any;
}): { type: string; data: any } => ({
  type: "UPDATE_BUSINESS_ADDRESS_OPTIONS",
  data,
});

export const updateBusinessAddressValidatedFlag = (data: {
  fieldKey: string;
  isValidated: boolean;
  // The normalized key of the address that was validated. Persisting it (instead
  // of a per-component ref) lets the validated state carry across wizard pages
  // that share a fieldKey, while still dropping when the address is truly edited.
  validatedKey?: string | null;
}): { type: string; data: any } => ({
  type: "UPDATE_BUSINESS_ADDRESS_VALIDATED_FLAG",
  data,
});

export const clearBusinessAddressSuggestions = (data: {
  fieldKey: string;
}): { type: string; data: any } => ({
  type: "CLEAR_BUSINESS_ADDRESS_SUGGESTIONS",
  data,
});
